import type { SectionId } from "@/components/landing/StoreCustomizer/types";
import ToggleSwitch from "@/components/landing/StoreCustomizer/ToggleSwitch";

interface SectionVisibilityListProps {
	label: string;
	sections: Record<SectionId, string>;
	visible: Record<SectionId, boolean>;
	accent: string;
	onToggle: (id: SectionId) => void;
}

function SectionVisibilityList(prop: SectionVisibilityListProps) {
	const { label, sections, visible, accent, onToggle } = prop;
	return (
		<div>
			<p className="mb-2.5 text-xs font-semibold text-muted-foreground">{label}</p>
			<div className="flex flex-col gap-2.5">
				{(Object.keys(sections) as SectionId[]).map((id) => (
					<div key={id} className="flex items-center justify-between gap-3">
						<span id={`section-visibility-${id}`} className="text-[13px]">
							{sections[id]}
						</span>
						<ToggleSwitch
							on={visible[id]}
							onToggle={() => onToggle(id)}
							accent={accent}
							label={sections[id]}
							labelledBy={`section-visibility-${id}`}
						/>
					</div>
				))}
			</div>
		</div>
	);
}

export default SectionVisibilityList;
